import { RawMeasurementQU } from './Common'

export type HarvestStateObject = {
  area?: RawMeasurementQU;
  avgMoisture?: RawMeasurementQU;
  avgYield?: RawMeasurementQU;
}
export enum HarvestKey {
  YIELD = 'yield',
  MOISTURE = 'moisture',
  DATE = 'harvestdate',
  COMBINE_SPEED = 'combinespeed',
}
